import { lazy } from 'react';
export const ContainerIcons = {
    Group1Outlined: lazy(() => import('./Icons/Group1Outlined')),
    Group1Filled: lazy(() => import('./Icons/Group1Filled')),
    Group2Outlined: lazy(() => import('./Icons/Group2Outlined')),
    Group2Filled: lazy(() => import('./Icons/Group2Filled')),
    Group3Outlined: lazy(() => import('./Icons/Group3Outlined')),
    Group3Filled: lazy(() => import('./Icons/Group3Filled')),
    Group4Outlined: lazy(() => import('./Icons/Group4Outlined')),
    Group4Filled: lazy(() => import('./Icons/Group4Filled')),
    Other1Outlined: lazy(() => import('./Icons/Other1Outlined')),
    Other2Filled: lazy(() => import('./Icons/Other2Filled')),
    Other3Filled: lazy(() => import('./Icons/Other3Filled')),
    Other4Filled: lazy(() => import('./Icons/Other4Filled')),
    Other5Filled: lazy(() => import('./Icons/Other5Filled')),
};
